import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=4e9c0b72&scoped=true"
import script from "./BrandItem.vue?vue&type=script&lang=js"
export * from "./BrandItem.vue?vue&type=script&lang=js"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=4e9c0b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c0b72",
  null
  
)

export default component.exports